// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"181":"55fef1e0","628":"e3b96a9d"}[chunkId] + ".css";
};